import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { Mail, Globe, ArrowUpRight } from "lucide-react";
import { CONTACT } from "../data/site";

const COLS = [
  {
    title: "Company",
    links: [
      { to: "/about", label: "About S&B" },
      { to: "/services", label: "Services" },
      { to: "/investors", label: "Investor Opportunities" },
      { to: "/contact", label: "Contact" },
    ],
  },
  {
    title: "Portfolio",
    links: [
      { to: "/domain-portfolio", label: "Domain Portfolio" },
      { to: "/software-portfolio", label: "Software Portfolio" },
      { to: "/domain-portfolio#why", label: "Why Premium Domains" },
    ],
  },
  {
    title: "Services",
    links: [
      { to: "/services#software-development", label: "Software Development" },
      { to: "/services#website-design", label: "Website Design" },
      { to: "/services#business-consulting", label: "Business Consulting" },
      { to: "/services#lead-generation", label: "Lead Generation" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-slate-50 border-t border-slate-200 pt-20 pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Logo size="md" />
            <p className="mt-6 text-sm text-slate-600 leading-relaxed max-w-md">
              {CONTACT.tagline}
            </p>
            <p className="mt-4 text-sm text-slate-500 max-w-md">
              Building the future of digital business infrastructure through software
              development, digital asset ownership, consulting, and domain acquisition.
            </p>

            <div className="mt-8 space-y-3">
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="footer-email-link"
                className="group inline-flex items-center gap-3 text-sm text-slate-700 hover:text-[#0066FF] transition-colors"
              >
                <span className="flex h-8 w-8 items-center justify-center border border-slate-300 group-hover:border-[#0066FF] group-hover:text-[#0066FF] transition-colors">
                  <Mail size={14} />
                </span>
                {CONTACT.email}
              </a>
              <div className="flex items-center gap-3 text-sm text-slate-700">
                <span className="flex h-8 w-8 items-center justify-center border border-slate-300">
                  <Globe size={14} />
                </span>
                {CONTACT.website}
              </div>
            </div>
          </div>

          {COLS.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <div className="eyebrow mb-5">{col.title}</div>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className="group inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-[#0066FF] transition-colors"
                    >
                      {l.label}
                      <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1">
            <div className="eyebrow mb-5">Legal</div>
            <ul className="space-y-3 text-sm text-slate-600">
              <li>Terms</li>
              <li>Privacy</li>
            </ul>
          </div>
        </div>

        <div className="glow-line mt-16" />

        <div className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs text-slate-500 font-mono uppercase tracking-[0.2em]">
            © 2026 S&amp;B Technologies. All Rights Reserved.
          </p>
          <p className="text-xs text-slate-500 font-mono uppercase tracking-[0.2em]">
            Founded by Shawn Williams &amp; Brittney Williams
          </p>
        </div>
      </div>
    </footer>
  );
}
